import { Routes } from '@angular/router';
import {LanguageRedirectGuard, RentalResolver, SeoResolver, HomeComponent} from "@olivades/pattern-lib";

export const SEO_PAGES: Record<string, { fr: { title: string; description: string; keywords?: string[] }, en: { title: string; description: string; keywords?: string[] } }> = {
  home: {
    fr: {
      title: 'Résidence Melody - Accueil',
      description: 'Bienvenue à la Résidence Melody, votre lieu de séjour idéal à Saint Rémy de Provence.',
      keywords: ['résidence melody', 'Saint Rémy de Provence', 'location vacances', 'accueil']
    },
    en: {
      title: 'Melody Residence - Home ',
      description: 'Welcome to Melody Residence, your ideal stay in Saint Remy de Provence.',
      keywords: ['melody residence', 'Saint Remy de Provence', 'holiday rental', 'home']
    }
  },
  rentals: {
    fr: {
      title: 'Locations - Résidence Melody, Saint Rémy de Provence',
      description: 'Découvrez nos locations à la Résidence Melody à Saint Rémy de Provence.',
      keywords: ['locations', 'résidence melody', 'Saint Rémy de Provence']
    },
    en: {
      title: 'Rentals - Melody Residence, Saint Remy de Provence',
      description: 'Discover our rentals at Melody Residence in Saint Remy de Provence.',
      keywords: ['rentals', 'melody residence', 'Saint Remy de Provence']
    }
  },
  faq: {
    fr: {
      title: 'FAQ - Résidence Melody',
      description: 'Foire aux questions sur votre séjour à la Résidence Melody.',
      keywords: ['FAQ', 'résidence melody', 'questions', 'Saint Rémy de Provence']
    },
    en: {
      title: 'FAQ - Melody Residence',
      description: 'Frequently asked questions about your stay at Melody Residence.',
      keywords: ['FAQ', 'melody residence', 'questions', 'Saint Remy de Provence']
    }
  },
  contact: {
    fr: {
      title: 'Contact - Résidence Melody',
      description: 'Contactez la Résidence Melody à Saint Rémy de Provence.',
      keywords: ['contact', 'résidence melody', 'Saint Rémy de Provence']
    },
    en: {
      title: 'Contact - Melody Residence',
      description: 'Contact Melody Residence in Saint Remy de Provence.',
      keywords: ['contact', 'melody residence', 'Saint Remy de Provence']
    }
  },
  gallery: {
    fr: {
      title: 'Galerie - Résidence Melody',
      description: 'Découvrez la galerie photo de la Résidence Melody à Saint Rémy de Provence.',
      keywords: ['galerie', 'photos', 'résidence melody', 'Saint Rémy de Provence']
    },
    en: {
      title: 'Gallery - Melody Residence',
      description: 'Discover the photo gallery of Melody Residence in Saint Remy de Provence.',
      keywords: ['gallery', 'photos', 'melody residence', 'Saint Remy de Provence']
    }
  }
};

export const ROUTES_TRANSLATIONS: Record<string, Record<'fr' | 'en', string>> = {
  home: { fr: 'accueil', en: 'home' },
  locations: { fr: 'locations', en: 'rentals' },
  locationDetail: { fr: 'locations/:slug', en: 'rentals/:slug' },
  faq: { fr: 'faq', en: 'faq' },
  contact: { fr: 'contact', en: 'contact' },
  gallery: { fr: 'gallery', en: 'gallery' }
};

const LANGUAGES: ('fr' | 'en')[] = ['fr', 'en'];

export const routes: Routes = [
  {
    path: '',
    canActivate: [LanguageRedirectGuard],
    component: HomeComponent
  },
  ...LANGUAGES.map(lang => ({
    path: lang,
    children: [
      {
        path: ROUTES_TRANSLATIONS['home'][lang],
        loadComponent: () => import('@olivades/pattern-lib').then(m => m.HomeComponent!),
        resolve: { seo: SeoResolver },
        data: { lang, seoPage: 'home', routeName: 'home' }
      },
      {
        path: ROUTES_TRANSLATIONS['locations'][lang],
        loadComponent: () => import('@olivades/pattern-lib').then(m => m.RentsLayoutComponent!),
        resolve: { seo: SeoResolver },
        data: { lang, seoPage: 'rentals', routeName: 'locations' }
      },
      {
        path: ROUTES_TRANSLATIONS['locationDetail'][lang],
        loadComponent: () => import('@olivades/pattern-lib').then(m => m.RentDetailsLayoutComponent!),
        resolve: { rental: RentalResolver },
        data: { lang, routeName: 'locationDetail' }
      },
      {
        path: ROUTES_TRANSLATIONS['faq'][lang],
        loadComponent: () => import('@olivades/pattern-lib').then(m => m.FaqComponent!),
        resolve: { seo: SeoResolver },
        data: { lang, seoPage: 'faq', routeName: 'faq' }
      },
      {
        path: ROUTES_TRANSLATIONS['contact'][lang],
        loadComponent: () => import('@olivades/pattern-lib').then(m => m.ContactComponent!),
        resolve: { seo: SeoResolver },
        data: { lang, seoPage: 'contact', routeName: 'contact' }
      },
      {
        path: ROUTES_TRANSLATIONS['gallery'][lang],
        loadComponent: () => import('@olivades/pattern-lib').then(m => m.GalleryLayoutComponent!),
        resolve: { seo: SeoResolver },
        data: { lang, seoPage: 'gallery', routeName: 'gallery' }
      }
    ]
  })),
  { path: '**', redirectTo: 'fr', pathMatch: 'full' }
];
